var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-1 table",
    attrs: {
      headers: _vm.encabezados,
      items: _vm.visitas,
      search: _vm.busqueda,
      pagination: _vm.pageConfig,
      "no-data-text": "No hay registros",
      "no-results-text": "No hay registros"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pageConfig = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function(visita) {
          return [
            _c("td", [_vm._v(_vm._s(visita.item.patente))]),
            _c("td", [_vm._v(_vm._s(visita.item.caso))]),
            _c("td", [_vm._v(_vm._s(visita.item.fechaCoordinacion))]),
            _c("td", [_vm._v(_vm._s(visita.item.tecnicoNombre))]),
            _c("td", [_vm._v(_vm._s(visita.item.clienteContactado))]),
            _c("td", [_vm._v(_vm._s(visita.item.estado))]),
            _c("td", [_vm._v(_vm._s(visita.item.identificador))]),
            _c("td", [_vm._v(_vm._s(visita.item.tipoVisita))]),
            _c("td", [_vm._v(_vm._s(visita.item.fechaCierreCaso))]),
            _c("td", [_vm._v(_vm._s(visita.item.glosa))])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }